/* IVYN Theme JavaScript */

// ── Sticky header
const siteHeader = document.getElementById('site-header');
if (siteHeader) {
  window.addEventListener('scroll', () => {
    siteHeader.classList.toggle('scrolled', window.scrollY > 8);
  }, { passive: true });
}

// ── Mobile menu
const mobNav = document.getElementById('mob-nav');
const hamBtn = document.getElementById('ham-btn');
const mobClose = document.getElementById('mob-close');
document.querySelectorAll('.mob-head').forEach((btn) => {
  btn.addEventListener('click', () => {
    const section = btn.closest('.mob-section');
    if (!section) return;
    const isOpen = !section.classList.contains('open');
    section.classList.toggle('open', isOpen);
    btn.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    const symbol = btn.querySelector('.mob-head-symbol');
    if (symbol) symbol.textContent = isOpen ? '-' : '+';
  });
});
if (hamBtn && mobNav) {
  hamBtn.addEventListener('click', () => {
    mobNav.classList.add('open');
    document.body.classList.add('mob-nav-open');
    hamBtn.setAttribute('aria-expanded', 'true');
  });
}
if (mobClose && mobNav) {
  mobClose.addEventListener('click', () => {
    mobNav.classList.remove('open');
    document.body.classList.remove('mob-nav-open');
    if (hamBtn) hamBtn.setAttribute('aria-expanded', 'false');
  });
}

// ── Hero slideshow
(function () {
  const slides = [...document.querySelectorAll('.slide')];
  const dots   = [...document.querySelectorAll('.dot')];
  if (!slides.length) return;
  let cur = 0, tmr;

  function goTo(n) {
    slides[cur].classList.remove('on');
    if (dots[cur]) dots[cur].classList.remove('on');
    cur = (n + slides.length) % slides.length;
    slides[cur].classList.add('on');
    if (dots[cur]) dots[cur].classList.add('on');
  }
  function resetTimer() {
    clearInterval(tmr);
    tmr = setInterval(() => goTo(cur + 1), 5800);
  }

  const nextBtn = document.getElementById('hero-next');
  const prevBtn = document.getElementById('hero-prev');
  if (nextBtn) nextBtn.addEventListener('click', () => { goTo(cur + 1); resetTimer(); });
  if (prevBtn) prevBtn.addEventListener('click', () => { goTo(cur - 1); resetTimer(); });
  dots.forEach(d => d.addEventListener('click', () => { goTo(+d.dataset.to); resetTimer(); }));

  // Swipe
  let tx = 0;
  const heroEl = document.getElementById('hero-section');
  if (heroEl) {
    heroEl.addEventListener('touchstart', e => { tx = e.touches[0].clientX; }, { passive: true });
    heroEl.addEventListener('touchend', e => {
      const dx = e.changedTouches[0].clientX - tx;
      if (Math.abs(dx) > 50) { dx < 0 ? goTo(cur + 1) : goTo(cur - 1); resetTimer(); }
    });
  }
  resetTimer();
})();
// ── Product page gallery (legacy) — PATCHED 19 Jul 2026
// Fix 1: exit when the modern PDP slider (#gslider-track in product-main.liquid) owns the
//        gallery — double-binding crashed on every thumbnail tap and desynced image classes.
// Fix 2: NaN/bounds guards — markup uses data-index, so +t.dataset.idx was always NaN.
(function () {
  if (document.getElementById('gslider-track')) return; /* modern PDP gallery controller present */
  const imgEls   = document.querySelectorAll('.gallery-main img');
  const thumbEls = document.querySelectorAll('.thumb');
  if (!imgEls.length) return;
  let currentImg = 0;

  function showImg(idx) {
    idx = parseInt(idx, 10);
    if (!Number.isFinite(idx)) idx = 0;
    const prevEl = imgEls[currentImg];
    if (prevEl) prevEl.classList.replace('active', 'hidden');
    if (thumbEls[currentImg]) thumbEls[currentImg].classList.remove('active');
    currentImg = ((idx % imgEls.length) + imgEls.length) % imgEls.length;
    const nextEl = imgEls[currentImg];
    if (nextEl) nextEl.classList.replace('hidden', 'active');
    if (thumbEls[currentImg]) thumbEls[currentImg].classList.add('active');
  }

  thumbEls.forEach(t => t.addEventListener('click', () =>
    showImg(t.dataset.idx != null ? t.dataset.idx : t.dataset.index)));
  const galNext = document.getElementById('gal-next');
  const galPrev = document.getElementById('gal-prev');
  if (galNext) galNext.addEventListener('click', () => showImg(currentImg + 1));
  if (galPrev) galPrev.addEventListener('click', () => showImg(currentImg - 1));

  // Swipe
  let gx = 0;
  const mainImg = document.getElementById('main-img');
  if (mainImg) {
    mainImg.addEventListener('touchstart', e => { gx = e.touches[0].clientX; }, { passive: true });
    mainImg.addEventListener('touchend', e => {
      const dx = e.changedTouches[0].clientX - gx;
      if (Math.abs(dx) > 40) showImg(dx < 0 ? currentImg + 1 : currentImg - 1);
    });
  }
})();

// ── Product Card Swatches (homepage / collection page)
(function() {
  function initSwatches() {
    document.querySelectorAll('.pswatch').forEach(function(btn) {
      if (btn.dataset.swatchInit) return;
      btn.dataset.swatchInit = '1';
      btn.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        var productId   = btn.dataset.productId;
        var variantId   = btn.dataset.variantId;
        var color       = (btn.dataset.color || '').toLowerCase();
        var url         = btn.dataset.url;
        var wrap        = btn.closest('.pc-wrap');
        var link        = wrap ? wrap.querySelector('.pc') : null;
        var mainImg     = wrap ? wrap.querySelector('.img-main') : null;
        var hoverImg    = wrap ? wrap.querySelector('.img-hover') : null;
        var swatchGroup = wrap ? wrap.querySelectorAll('.pswatch') : [];

        swatchGroup.forEach(function(s) { s.classList.remove('active'); });
        btn.classList.add('active');

        if (link && url) link.href = url;

        if (!link) return;
        var allImgs = link.querySelectorAll('.pi img');
        var matched = [];
        allImgs.forEach(function(img) {
          if ((img.alt || '').toLowerCase().indexOf(color) !== -1) matched.push(img);
        });

        // Use variant image src directly from data attribute if available
        var variantSrc = btn.dataset.imgSrc;
        var hoverSrc   = btn.dataset.hoverSrc;
        if (variantSrc && mainImg) {
          mainImg.src = variantSrc;
          mainImg.removeAttribute('srcset');
          if (hoverImg) {
            if (hoverSrc) {
              hoverImg.src = hoverSrc;
              hoverImg.style.display = '';
            } else {
              hoverImg.removeAttribute('src');
              hoverImg.style.display = 'none';
            }
            hoverImg.removeAttribute('srcset');
          }
        } else if (matched.length > 0 && mainImg) {
          mainImg.src = matched[0].src;
          mainImg.removeAttribute('srcset');
          if (hoverImg) {
            if (matched[1]) {
              hoverImg.src = matched[1].src;
              hoverImg.style.display = '';
            } else {
              hoverImg.removeAttribute('src');
              hoverImg.style.display = 'none';
            }
            hoverImg.removeAttribute('srcset');
          }
        }

        // Update extra slides to match selected colour
        var swatchesDiv = wrap ? wrap.querySelector('.pswatches') : null;
        if (swatchesDiv) {
          try {
            var colorImages = JSON.parse(swatchesDiv.dataset.colorImages || '{}');
            var colorImgList = colorImages[color] || [];
            if (colorImgList.length > 0) {
              var extraSlides = link.querySelectorAll('.pc-extra-slide');
              extraSlides.forEach(function(slide, i) {
                var extraIdx = i + 2;
                if (colorImgList[extraIdx]) slide.src = colorImgList[extraIdx];
              });
            }
          } catch(e) {}
        }

        // Reset card slider back to main image (slide 0) after colour change
        if (link) {
          var piEl = link.querySelector('.pi');
          if (piEl) {
            var allSlides = piEl.querySelectorAll('.img-main, .img-hover, .pc-extra-slide');
            allSlides.forEach(function(el, i) {
              el.style.transition = 'opacity 0.22s ease';
              el.style.opacity = el.classList.contains('img-main') ? '1' : '0';
              el.style.zIndex  = el.classList.contains('img-main') ? '2' : '1';
              el.style.transform = 'none';
            });
          }
          if (window.ivynCardReset) window.ivynCardReset(link);
        }
      });
    });
  }

  document.addEventListener('DOMContentLoaded', initSwatches);
  if (document.readyState !== 'loading') initSwatches();
})();

// ── Accordion — independent toggle per item, event delegation
document.addEventListener('click', function(e) {
  var head = e.target.closest('.acc-head');
  if (!head) return;
  var item = head.closest('.acc-item');
  if (!item) return;
  item.classList.toggle('open');
  var icon = head.querySelector('.acc-icon');
  if (icon) icon.textContent = item.classList.contains('open') ? '×' : '+';
  head.setAttribute('aria-expanded', item.classList.contains('open') ? 'true' : 'false');
});

// ── Size chart modal
(function () {
  const overlay    = document.getElementById('size-chart-overlay');
  const openLink   = document.getElementById('size-chart-link');
  const closeBtn   = document.getElementById('sc-close');
  if (!overlay) return;
  if (openLink)  openLink.addEventListener('click', e => { e.preventDefault(); overlay.classList.add('open'); });
  if (closeBtn)  closeBtn.addEventListener('click', () => overlay.classList.remove('open'));
  overlay.addEventListener('click', e => { if (e.target === overlay) overlay.classList.remove('open'); });
})();

// ── Filter panel JS
(function(){
  const toggleBtn = document.getElementById('filter-toggle-btn');
  const closeBtn  = document.getElementById('filter-close-btn');
  const applyBtn  = document.getElementById('filter-apply-btn');
  const panel     = document.getElementById('filter-panel');

  function openPanel() {
    if (!panel) return;
    panel.classList.add('open');
    document.body.style.overflow = 'hidden';
  }
  function closePanel() {
    if (!panel) return;
    panel.classList.remove('open');
    document.body.style.overflow = '';
  }

  if (toggleBtn) toggleBtn.addEventListener('click', openPanel);
  if (closeBtn)  closeBtn.addEventListener('click', closePanel);
  if (applyBtn)  applyBtn.addEventListener('click', closePanel);

  if (panel) {
    panel.addEventListener('click', function(e) {
      if (e.target === panel) closePanel();
    });
  }

  document.querySelectorAll('.filter-group-head[data-fg]').forEach(btn => {
    btn.addEventListener('click', function() {
      const targetId = this.dataset.fg;
      const body     = document.getElementById(targetId);
      if (!body) return;
      const isOpen = body.style.display !== 'none';
      body.style.display = isOpen ? 'none' : 'block';
      this.classList.toggle('active', !isOpen);
      const arrow = this.querySelector('.fg-arrow');
      if (arrow) arrow.textContent = isOpen ? '+' : '−';
    });
  });
})();

/* ══ TASK 3: Product card image slider ══ */
(function() {
  var state = {}; /* productId -> { cur, total, imgs[] } */

  function getCardImgs(pi) {
    var imgs = [];
    var main = pi.querySelector('.img-main');
    if (main) imgs.push({ el: main, type: 'main' });
    var hover = pi.querySelector('.img-hover');
    if (hover) imgs.push({ el: hover, type: 'hover' });
    pi.querySelectorAll('.pc-extra-slide').forEach(function(e) {
      imgs.push({ el: e, type: 'extra' });
    });
    return imgs;
  }

  function showCardSlide(pid, idx, dir) {
    var s = state[pid];
    if (!s) return;
    var n = s.imgs.length;
    if (n <= 1) return;
    var old = s.cur;
    idx = ((idx % n) + n) % n;
    dir = dir || (idx > old ? 1 : -1);
    s.cur = idx;

    s.imgs.forEach(function(item, i) {
      var el = item.el;
      var active = (i === idx);
      var wasActive = (i === old);
      el.style.transition = 'opacity 0.28s ease, transform 0.34s cubic-bezier(0.22, 1, 0.36, 1)';
      el.style.opacity = active ? '1' : '0';
      el.style.zIndex  = active ? '2' : '1';
      if (active) {
        el.style.transform = 'translate3d(0,0,0)';
      } else if (wasActive) {
        el.style.transform = 'translate3d(' + (dir > 0 ? '-18px' : '18px') + ',0,0)';
      } else {
        el.style.transform = 'translate3d(' + (dir > 0 ? '18px' : '-18px') + ',0,0)';
      }
    });
    var dotWrap = s.imgs[0] && s.imgs[0].el ? s.imgs[0].el.closest('.pi') : null;
    var dots = dotWrap ? dotWrap.querySelectorAll('.pc-swipe-dots i') : null;
    if (dots && dots.length) {
      dots.forEach(function(dot, i) {
        dot.classList.toggle('active', i === Math.min(idx, dots.length - 1));
      });
    }
  }

  window.ivynCardNav = function(btn, dir) {
    var pi  = btn.closest('.pi');
    var pcWrap = btn.closest('.pc-wrap');
    if (!pi || !pcWrap) return;
    var pcEl = pcWrap.querySelector('[id^="pc-"]');
    if (!pcEl) return;
    var pid = pcEl.id.replace('pc-', '');
    if (!state[pid]) initCard(pcWrap);
    var s = state[pid];
    if (!s) return;
    showCardSlide(pid, s.cur + dir, dir);
  };

  function initCard(wrap) {
    var pcEl = wrap.querySelector('[id^="pc-"]');
    if (!pcEl) return;
    var pid = pcEl.id.replace('pc-', '');
    if (state[pid]) return;
    var pi   = wrap.querySelector('.pi');
    if (!pi)  return;
    var imgs = getCardImgs(pi);
    state[pid] = { cur: 0, total: imgs.length, imgs: imgs };
    if (imgs.length > 1) {
      pi.classList.add('has-card-swipes');
      if (!pi.querySelector('.pc-swipe-dots')) {
        var dots = document.createElement('span');
        dots.className = 'pc-swipe-dots';
        dots.setAttribute('aria-hidden', 'true');
        dots.innerHTML = '<i class="active"></i><i></i><i></i>';
        pi.appendChild(dots);
      }
    }

    var tx = 0, ty = 0, horizontalSwipe = false, verticalSwipe = false;
    pi.addEventListener('touchstart', function(e) {
      tx = e.touches[0].clientX;
      ty = e.touches[0].clientY;
      horizontalSwipe = false;
      verticalSwipe = false;
    }, { passive: true });
    pi.addEventListener('touchmove', function(e) {
      if (verticalSwipe) return;
      var dx = Math.abs(e.touches[0].clientX - tx);
      var dy = Math.abs(e.touches[0].clientY - ty);
      if (!horizontalSwipe && dy > 8 && dy > dx) {
        verticalSwipe = true;
        return;
      }
      if (dx > 10 && dx > dy * 1.15) {
        horizontalSwipe = true;
        document.body.classList.add('ivyn-swipe-lock');
        e.preventDefault();
      }
    }, { passive: false });
    pi.addEventListener('touchend', function(e) {
      var diff = tx - e.changedTouches[0].clientX;
      var ydiff = ty - e.changedTouches[0].clientY;
      if (horizontalSwipe && Math.abs(diff) > 32 && Math.abs(diff) > Math.abs(ydiff)) {
        var dir = diff > 0 ? 1 : -1;
        showCardSlide(pid, state[pid].cur + dir, dir);
      }
      document.body.classList.remove('ivyn-swipe-lock');
    }, { passive: true });
    pi.addEventListener('touchcancel', function() {
      document.body.classList.remove('ivyn-swipe-lock');
    }, { passive: true });
  }

  window.ivynCardReset = function(link) {
    var pcWrap = link ? link.closest('.pc-wrap') : null;
    var pcEl = pcWrap ? pcWrap.querySelector('[id^="pc-"]') : null;
    var pi = pcWrap ? pcWrap.querySelector('.pi') : null;
    if (!pcEl || !pi) return;
    var pid = pcEl.id.replace('pc-', '');
    state[pid] = { cur: 0, total: 0, imgs: getCardImgs(pi) };
    state[pid].total = state[pid].imgs.length;
    state[pid].imgs.forEach(function(item) {
      var active = item.type === 'main';
      item.el.style.transition = 'opacity 0.22s ease';
      item.el.style.opacity = active ? '1' : '0';
      item.el.style.zIndex = active ? '2' : '1';
      item.el.style.transform = 'none';
    });
    var dots = pi.querySelectorAll('.pc-swipe-dots i');
    dots.forEach(function(dot, i) {
      dot.classList.toggle('active', i === 0);
    });
  };

  function initAll() { document.querySelectorAll('.pc-wrap').forEach(initCard); }
  document.addEventListener('DOMContentLoaded', initAll);
  if (document.readyState !== 'loading') initAll();
})();

/* ── Stop shimmer once images load ── */
(function() {
  function initShimmer() {
    document.querySelectorAll('.pi').forEach(function(pi) {
      if (pi.dataset.shimmerInit) return;
      pi.dataset.shimmerInit = '1';
      var img = pi.querySelector('.img-main');
      if (!img) return;
      if (img.complete && img.naturalWidth > 0) {
        pi.classList.add('img-loaded');
      } else {
        img.addEventListener('load', function() { pi.classList.add('img-loaded'); });
        img.addEventListener('error', function() { pi.classList.add('img-loaded'); });
      }
    });
  }
  document.addEventListener('DOMContentLoaded', initShimmer);
  if (document.readyState !== 'loading') initShimmer();
})();
